import React from "react";
import Particles from "react-particles-js";
import { useMediaQuery } from "react-responsive";
import HeroIntroMessages from "../../HeroIntroMessages";
import { ReactComponent as FaceHero } from "../../images/face-hero.svg";
import separator1 from "../../shapes/separator-1.svg";
import { heroParticlesConfig } from "../data/particlesConfig";
import QuickLinksMenu from "../components/QuickLinksMenu";

export default function HeroSection({ booted }) {
  const prefersReducedMotion = useMediaQuery({
    query: "(prefers-reduced-motion: reduce)",
  });

  return (
    <div className=" section container relative flex h-screen max-h-screen w-full flex-shrink-0 flex-col overflow-hidden">
      <div className="hero-particles-layer">
        <Particles
          className="particles absolute inset-0 z-0 h-full w-full"
          params={heroParticlesConfig}
        />
      </div>
      <div className="codec-shell" aria-label="Codec intro">
        <div className="codec-shell__viewport">
          <div className="codec-shell__hud codec-shell__hud--top">
            <span className="codec-shell__label"></span>
            <span className="codec-shell__freq" aria-hidden="true">
              8.8.8
            </span>
          </div>
          <div className="codec-shell__row">
            <div className="codec-shell__crt" aria-hidden="true">
              <div className="hero-face-wrap">
                <div className="hero-face-glitch">
                  <div className="hero-face-glitch__channel hero-face-glitch__channel--cyan">
                    <FaceHero className="hero-face-svg" />
                  </div>
                  <div className="hero-face-glitch__channel hero-face-glitch__channel--magenta">
                    <FaceHero className="hero-face-svg" />
                  </div>
                  <FaceHero className="hero-face-glitch__base hero-face-svg" />
                </div>
              </div>
            </div>
            <div className="codec-shell__dialog-wrapper" style={{ flexGrow: 1 }}>
              <div className="codec-shell__dialog codec-shell__dialog--thread">
                <p className="codec-shell__speaker">NERO</p>
                <HeroIntroMessages
                  prefersReducedMotion={prefersReducedMotion}
                  booted={booted}
                />
              </div>
            </div>
          </div>
          <div className="codec-shell__hud codec-shell__hud--bottom">
            <div className="codec-shell__bars" aria-hidden>
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>
            <span className="codec-shell__label"></span>
          </div>
        </div>
      </div>
      <div className="pointer-events-none absolute inset-x-0 top-0 z-30 flex justify-center px-4 pt-4 sm:px-6 sm:pt-6 lg:justify-start">
        <QuickLinksMenu
          className="hero-quick-menu pointer-events-auto"
          label="Quick links"
        />
      </div>
      <div className="hero-scroll-hint" aria-hidden="true">
        <span className="hero-scroll-hint__label">Scroll Down</span>
        <span className="hero-scroll-hint__mouse">
          <span className="hero-scroll-hint__wheel" />
        </span>
        <span className="hero-scroll-hint__chevrons">
          <span />
          <span />
        </span>
      </div>
      <div
        className="hero-separator pointer-events-none absolute left-0 right-0 z-10 box-border select-none"
        style={{
          top: "calc(100% - 39px)",
          backgroundImage: `url(${separator1})`,
        }}
        aria-hidden
      />
    </div>
  );
}
